<template>
  <div class="row" id="avaliation-response-form">
    <div class="col-12">
      <h2>{{ avaliation.name }}</h2>
    </div>
    <div class="col-12">
      <div v-html="avaliation.description"></div>
    </div>
    <hr/>
    <div class="col-12" v-for="(avaliationItem, index) in avaliationItems" :key="avaliationItem.id">
      <avaliation-item-response-form :avaliation-item="avaliationItem" :value="formData[index]" @input="setAvaliationItemResponse($event, index)" />
    </div>
  </div>
</template>

<script>
import AvaliationItemResponseForm from "@/components/Avaliation/AvaliationItemResponse/AvaliationItemResponseForm.vue";

export default {
  name: "AvaliationResponseForm",
  components: {
    AvaliationItemResponseForm,
  },
  props: {
    avaliation: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  methods: {
    setAvaliationItemResponse(avaliationItemResponse, index) {
      this.formData[index] = avaliationItemResponse
      this.formData = [...this.formData];
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    avaliationItems() {
      return (this.avaliation && this.avaliation.avaliation_items) || [];
    },
  },
}
</script>

<style style="scss">
#avaliation-response-form {
  overflow-wrap: break-word;

  p {
    margin-bottom: 12px;
    line-height: 25px;
    font-size: 0.9rem;
    font-weight: 400;
  }
}
</style>
